<template>
  <div>
    <v-text-field
      v-model.trim="searchString"
      solo
      width="20"
      hide-details
      :placeholder="placeholder"
      prepend-inner-icon="mdi-magnify"
      class="search-input" />
  </div>
</template>
<script>
import {
  debounce, isObject,
} from 'lodash';
export default {
  name: 'AppSearchRowsInput',
  props: {
    searchFor: {
      type: [Array, String],
      required: true, // ['id', 'name'] or 'name'
    },
    items: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Search for',
    },
  },
  data() {
    return {
      searchString: '',
      filteredItems: [],
    };
  },
  computed: {
    filterFunction() {
      if (Array.isArray(this.searchFor)) {
        return this.filterFunctionArray;
      }
      return this.filterFunctionString;
    },
  },
  watch: {
    searchString() {
      this.searchForItems();
    },
    items: {
      handler() {
        this.searchForItems();
      },
      immediate: true,
    },
    filteredItems() {
      this.$emit('found-items', this.filteredItems);
    },
  },
  methods: {
    searchForItems: debounce(function () {
      const { items, filterFunction, searchString } = this;
      if (!items.length || !searchString) {
        this.filteredItems = items;
        return;
      }
      this.filteredItems = items.filter(item => filterFunction(item, searchString));
    }, 500),
    compare(itemToFilter, textToSearch, searchFor = null) {
      if (!itemToFilter || !itemToFilter[searchFor]) return false;
      return itemToFilter[searchFor].toLowerCase().includes(textToSearch.toLowerCase());
    },
    filterFunctionArray(itemToFilter, textToSearch, searchFor = null) {
      const { compare } = this;
      if (!searchFor) {
        searchFor = this.searchFor;
      }
      return searchFor.some(s => {
        if (isObject(s)) {
          const [sKey, sValue] = Object.entries(s)[0];
          return sValue.some(val => compare(itemToFilter[sKey], textToSearch, val));
        }
        return compare(itemToFilter, textToSearch, s);
      });
    },
    filterFunctionString(itemToFilter, textToSearch, searchFor) {
      if (!searchFor) {
        searchFor = this.searchFor;
      }
      const { compare } = this;
      return compare(itemToFilter, textToSearch, searchFor);
    },
  },
};
</script>
<style scoped>
</style>
